import Vue from "vue";
import VueDriver from "vue-driver.js";

Vue.use(VueDriver);